// NPM PACKAGE IMPORTS
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

// STYLE IMPORTS
import { Wrapper, Link, Image, Logout } from "../styled/Products";

// ASSET IMPORTS

import fabpro from "../../assets/fabpro.png";
import { buildFabTokenHandoffUrl } from "../sso/authUtils";

// EXPORTS
export default ({ setToken, token }) => {
  const handleLogout = () => {
    localStorage.removeItem("msuite_token");
    setToken(null);
  };

  //this shouldnt happen but if they somehow get to the login portal with a token set this will check to see if they should be sent back to FabPro
  localStorage.removeItem("msuite_token");
  window.location.assign(buildFabTokenHandoffUrl(token));
  return;

  return (
    <>
      <Wrapper>
        <Link href={buildFabTokenHandoffUrl(token)} onClick={handleLogout}>
          <Image src={fabpro} alt="Link to FabPro" />
        </Link>
      </Wrapper>
      <Logout onClick={handleLogout}>
        <FontAwesomeIcon icon={faArrowLeft} />
      </Logout>
    </>
  );
};
